/**
 * CRD Web API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReferralCreationEmailNotificationDetail { 
    attemptCount?: number;
    body?: string;
    contentType?: string;
    lastAttemptAt?: string;
    lastError?: string;
    notificationId?: string;
    programReferralId?: string;
    queuedAt?: string;
    recipientEmail?: string;
    recipientType?: ReferralCreationEmailNotificationDetail.RecipientTypeEnum;
    sentAt?: string;
    status?: ReferralCreationEmailNotificationDetail.StatusEnum;
    subject?: string;
}
export namespace ReferralCreationEmailNotificationDetail {
    export const RecipientTypeEnum = {
        ProgramAssignedUser: 'PROGRAM_ASSIGNED_USER',
        ProbationOfficer: 'PROBATION_OFFICER'
    } as const;
    export type RecipientTypeEnum = typeof RecipientTypeEnum[keyof typeof RecipientTypeEnum];
    export const StatusEnum = {
        Pending: 'PENDING',
        Processing: 'PROCESSING',
        Sent: 'SENT',
        Failed: 'FAILED',
        Suppressed: 'SUPPRESSED'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


